import ScrollReveal from './ScrollReveal';

// 全屏区块包装器：统一内边距、标题样式、滚动揭示
export default function SectionWrapper({ id, title, subtitle, children, className = '' }) {
  return (
    <section id={id} className={`full-section ${className}`}>
      <div className="max-w-[1920px] mx-auto w-full">
        <ScrollReveal>
          <h2 className="section-title text-gradient-gold">{title}</h2>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
        </ScrollReveal>
        <div className="mt-4">{children}</div>
      </div>
    </section>
  );
}
